export default function () {
  return {
    activePolicyNumbers: undefined,
    excessTotal: undefined,
    excessRemaining: undefined,
    loadingPolicies: [],
  };
}
